import React, { useState } from "react";
import "./css/StandardsCatalogue.css";
import { standardsCatalogueData } from "./standardsCatalogueData";

const categories = [
  "Agriculture",
  "Chemical technology", 
  "Civil engineering materials and works",
  "Electrotechincal",
  "Domestic and commercial equipment, entertainment, sports",
  "Electrical and electronics engineering",
  "Energy and heat transfer engineering",
  "Environment, health protection and safety",
  "Food technology",
  "Healthcare technology",
  "Information technology",
  "Metrology and measurement",
  "Mining and minerals",
  "Packaging and distribution of goods",
  "Paper technology",
  "Petroleum and related technologies",
  "Rubber and plastics",
  "Services",
  "Textiles and leather technology",
  "Wood technology",
];

const StandardsCatalogue = () => {
  const [search, setSearch] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("All");

  const [showModal, setShowModal] = useState(false);
  const [selectedStandard, setSelectedStandard] = useState(null);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  // Search query
  const query = search.trim().toLowerCase();

  // Filtered standards
  const filteredStandards = standardsCatalogueData.filter((s) => {
    const matchesSearch =
      !query ||
      s.code.toLowerCase().includes(query) ||
      s.title.toLowerCase().includes(query) ||
      s.description.toLowerCase().includes(query);

    const matchesCategory =
      categoryFilter === "All" || s.sector === categoryFilter;

    return matchesSearch && matchesCategory;
  });

  // Pagination calculations
  const totalPages = Math.ceil(filteredStandards.length / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;

  const currentStandards = filteredStandards.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const goToPage = (page) => {
    if (page < 1) page = 1;
    else if (page > totalPages) page = totalPages;

    setCurrentPage(page);
  };

  const openModal = (standard) => {
    setSelectedStandard(standard);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedStandard(null);
  };

  return (
    <div className="container">
      {/* Header */}
      <div
        className="header text-center catalogueBG"
        style={{ padding: "130px 0" }}
      >
        <h1 className="text-white animate-heading">
          Buy Malawi Standards Today!
        </h1>
      </div>

      <br />

      {/* Search + Filters */}
      <div className="row mt-4 mb-3">
        <div className="col-md-12">
          <h4>OUR STANDARDS</h4>

          <div
            className="d-flex flex-wrap align-items-center"
            style={{ gap: "15px" }}
          >
            {/* Search */}
            <input
              type="text"
              className="form-control"
              placeholder="Search by MS Number, Title or Description"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
              style={{ flex: "1 1 300px" }}
            />

            {/* Sector Dropdown */}
            <select
              className="form-control"
              value={categoryFilter}
              onChange={(e) => {
                setCategoryFilter(e.target.value);
                setCurrentPage(1);
              }}
              style={{ width: "250px" }}
            >
              <option value="All">All Sectors</option>

              {categories.map((cat, index) => (
                <option key={index} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="row">
        <div className="col-md-12">
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                <th>MS NUMBER</th>
                <th>TITLE</th>
                <th>SECTOR</th>
                {/* <th>DATE GAZETTED</th>
                <th>STATUS OF IMPLEMENTATION</th> */}
                <th>NUMBER OF PAGES</th>
                <th>ACTIONS</th>
              </tr>
            </thead>

            <tbody>
              {currentStandards.length > 0 ? (
                currentStandards.map((s, i) => (
                  <tr key={i}>
                    <td
                      className="open-modal"
                      style={{
                        cursor: "pointer",
                        color: "#007bff",
                        textDecoration: "underline",
                      }}
                      onClick={() => openModal(s)}
                    >
                      {s.code}
                    </td>

                    <td
                      className="open-modal"
                      style={{
                        cursor: "pointer",
                        color: "#007bff",
                        textDecoration: "underline",
                      }}
                      onClick={() => openModal(s)}
                    >
                      {s.title}
                    </td>

                    <td>{s.sector}</td>
                    {/* <td>{s.date_gazetted}</td>
                    <td>{s.status || "-"}</td> */}
                    <td>{s.pages || "-"}</td>

                    <td>
                      <button
                        style={{
                          backgroundColor: "#ff6600",
                          color: "white",
                          border: "none",
                          borderRadius: "20px",
                          padding: "6px 16px",
                          fontWeight: "bold",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          // window.open("http://192.168.0.5:3005", "_blank")
                          window.open("#")
                        }
                      >
                        Buy Standard
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No standards found
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-between align-items-center mt-3">
              <button
                className="btn btn-outline-primary"
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </button>

              <span>
                Page {currentPage} of {totalPages}
              </span>

              <button
                className="btn btn-outline-primary"
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          )}

          {/* Modal */}
          {showModal && selectedStandard && (
            <div
              className="modal-overlay"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(0,0,0,0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1000,
              }}
              onClick={closeModal}
            >
              <div
                className="modal-content bg-white p-4 rounded"
                style={{
                  width: "50%",
                  maxWidth: "600px",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <p style={{ fontWeight: "bold", fontSize: "18px" }}>
                  {selectedStandard.code}
                </p>

                <p style={{ fontWeight: "500", fontSize: "16px" }}>
                  {selectedStandard.title}
                </p>

                <p style={{ margin: "10px 0" }}>
                  {selectedStandard.description}
                </p>

                <p>
                  <strong>Sector:</strong> {selectedStandard.sector}
                </p>

                <p>
                  <strong>Date gazetted:</strong>{" "}
                  {selectedStandard.date_gazetted}
                </p>

                <p>
                  <strong>Status of implementation:</strong>{" "}
                  {selectedStandard.status || "-"}
                </p>

                <p>
                  <strong>Number of pages:</strong>{" "}
                  {selectedStandard.pages || "-"}
                </p>

                <div className="text-center mt-4">
                  <button
                    onClick={closeModal}
                    style={{
                      backgroundColor: "#FF6600",
                      color: "white",
                      border: "none",
                      borderRadius: "5px",
                      padding: "6px 16px",
                      fontWeight: "bold",
                      cursor: "pointer",
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default StandardsCatalogue;